
import React from 'react';
import { Loader2 } from 'lucide-react';

interface PageLoaderProps {
  message?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({ message = 'Loading page...' }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-200px)]">
      <Loader2 className="h-10 w-10 text-nalc-teal animate-spin mb-4" />
      <p className="text-lg font-medium text-muted-foreground">{message}</p>
    </div>
  );
};

export default PageLoader;
